<script setup>
import { computed } from 'vue'
import { useDrawer } from '../composables/useDrawer.js'
import { useUnits } from '../composables/useUnits.js'
import { useI18n } from '../i18n/index.js'
import UiIcon from './icons/UiIcon.vue'
import OPERALogo from './icons/OPERALogo.vue'

const { t } = useI18n()

const props = defineProps({
  title: { type: String, default: '' },
  showUnitToggle: { type: Boolean, default: true }
})
const emit = defineEmits(['search'])

const { show } = useDrawer()
const { unit, setUnit } = useUnits()

const tabs = [
  { id: 'F', label: '°F' },
  { id: 'C', label: '°C' }
]
const active = computed(() => unit.value)
</script>

<template>
  <header class="appbar" :class="{ 'appbar--dark': true }">
    <button class="appbar__btn" :aria-label="$t('nav.open')" @click="show">
      <UiIcon name="menu" :size="22" />
    </button>

    <div class="appbar__brand" :aria-label="$t('appbar.brand')">
      <!-- <OPERALogo :width="80" :height="18" /> -->
      <span class="appbar__vertical">{{ title || t('app.title') }}</span>
    </div>

    <div class="appbar__right">
      <div
        v-if="showUnitToggle"
        class="unit"
        role="radiogroup" :aria-label="$t('appbar.unit')"
      >
        <button
          v-for="t in tabs" :key="t.id"
          class="unit__btn" :class="{ 'unit__btn--on': active === t.id }"
          role="radio" :aria-checked="active === t.id"
          @click="setUnit(t.id)"
        >{{ t.label }}</button>
      </div>
      <!-- <button class="appbar__btn" :aria-label="$t('appbar.search')" @click="emit('search')">
        <UiIcon name="search" :size="20" />
      </button> -->
    </div>
  </header>
</template>

<style scoped>
.appbar {
  position: sticky; top: 0; z-index: 30;
  height: var(--appbar-h);
  display: grid; grid-template-columns: 44px 1fr auto; align-items: center;
  padding: 0 var(--sp-2) 0 var(--sp-1);
  /* 顶栏同样是「10% 白」玻璃，加背景模糊让下方内容透出但不干扰阅读 */
  background: var(--surface);
  backdrop-filter: var(--surface-blur);
  -webkit-backdrop-filter: var(--surface-blur);
  border-bottom: 1px solid var(--hairline);
  color: var(--text-primary);
}
.appbar__btn {
  width: 40px; height: 40px; display: grid; place-items: center;
  border-radius: var(--r-pill); color: var(--text-primary);
}
.appbar__btn:hover { background: var(--hover-tint); }
.appbar__brand { display: flex; align-items: center; gap: 6px; padding-left: 2px; }
.appbar__vertical { font-size: 16px; font-weight: 600; letter-spacing: .4px; }
.appbar__right { display: flex; align-items: center; gap: var(--sp-1); padding-right: 2px; }

.unit {
  display: inline-flex; align-items: center; gap: 2px;
  background: var(--surface-strong); border-radius: var(--r-pill); padding: 2px;
}
.unit__btn {
  min-width: 38px; height: 26px; padding: 0 8px;
  border-radius: var(--r-pill); font-size: 13px; font-weight: 600;
  color: var(--text-secondary);
  transition: background var(--d-fast) var(--ease-out), color var(--d-fast) var(--ease-out);
}
/* 选中态保持高对比：深色页用白底深字，浅色页用深底白字 */
.unit__btn--on { background: #fff; color: #0a0e1f; }
:root[data-page="light"] .unit__btn--on { background: #101B24; color: #fff; }
</style>
